<template>
    <div class="exams-main">
        <div class="hasCategory ">
             <div class="exams-panel">
                <div class="exams-panel-body">
                       <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-right  flex align-cen">
                                 <div class="regulaOption flex align-cen">
                                    <el-select v-model="value1"   placeholder="内外部课程"
                                    @change="getList1"
                                    >
                                        <el-option
                                        v-for="item in option1"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                 <div class="regulaOption flex align-cen">
                                    <el-select v-model="value"  clearable placeholder="课程分类"
                                    @change="getList"
                                    >
                                        <el-option
                                        v-for="item in option"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                          <div class="exams-list">
                             <div class="public-tit flex" style="margin:10px 16px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  我的课程
                                    </div>
                                </div>
                            <div class="exams-scrollbar" v-if="itemList && itemList.length">
                                <div class="exams-item" v-for="(item,index) in itemList" >
                                    <div class="exams-item-info flex align-cen">
                                         <img :src="item.logo" alt="" class="courseimg">
                                         <div class="exams-item-info-rule flex">
                                            <div class="exams-item-paperName flg">
                                                    {{item.title}}
                                                </div>
                                                <div class="dateTit flg" style="margin:20px 0;margin-right:20px">
                                                    {{item.introduction}}
                                                </div>
                                                 <div class="dateTit  dateTit1 flg " style="margin-bottom:20px">
                                                    <span style="color:red;"  v-if="item.endTime">{{item.endTime}} 到期</span>
                                                    <span v-else>时间不限</span>
                                                </div>
                                                 <div class="dateTit dateTit1 flg flex">
                                                    <span >已更新{{item.chapterNum}}期</span>
                                                </div>
                                         </div>
                                         <div class="mft">
                                            <span v-if="item.learn == 1 && item.overTime == 0" class="coursebtn" @click="openVideo(item)">继续学习</span>
                                            <span v-if="item.learn == 0 && item.overTime == 0" class="coursebtn" @click="openVideo(item)">开始学习</span>
                                            <span v-if="item.overTime == 1" class="coursebtn" @click="openVideo(item)">学习试听</span>
                                            <span class="coursebtn1" @click="openCourseDetail(item)">
                                                查看课程
                                            </span>
                                         </div>
                                         <div class="gqimg" v-if="item.overTime == 1">
                                            <img src="../../assets/images/courseGq.png" alt="">
                                         </div>
                                    </div>
                                </div>
                            </div>
                          <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                          </div>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import {courseClassify1,courserMyList} from "@/api/enterprise/index"   //课程列表、我的课程分页
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'learningRecord',
      components:{
      paginaTion
    },
    data () {
        return {
               value1:0,
            option1:[
                {
                    id:1,
                    name:'平台课程'
                },
                {
                    id:0,
                    name:'企业内部课程'
                }
            ],
            totalCount:0,
            businessInfo:{},
            itemList:[],
            option:[],
            value:''
        }
    },
    created () {
           if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
       this.getClass()
       this.getList()
    },
    mounted () { 
    },
    methods: {
          getList1(){
            this.value=''
            this.getClass()
            this.getList()
        },
           // 打开试听课
        openVideo(data){
            const newurl = this.$router.resolve({name: 'HlrjenCourseVideo', query: {
                id: data.id,
                chapterId:data.chapterId,
                title:data.title,
                index:'',
                childIndex:''
                }})
       window.open(newurl.href,'_blank')
        this.getList()
        },
        // 打开课程详情
        openCourseDetail(data){
            const newurl = this.$router.resolve({name: 'HlrjenCourseDetail', query: {id: data.id}})
       window.open(newurl.href,'_blank')
        },
        // 获取课程分类
            getClass(){
                console.log(this.businessInfo)
           courseClassify1({name:'',isPlat:this.value1,businessId:this.businessInfo.id})
            .then(res =>{
                this.option = res.data
            })
        },
        // 获取我的课程分页
        getList(){
            courserMyList({businessId:this.businessInfo.id,classifyId:this.value,isPlat:this.value1})
            .then(res =>{
                this.itemList = res.data
            })
        },
            emitFun(val,val1){
    //     if(val1 == "PageSize") this.PageSize = val
    //    if(val1 == "currentPage") this.currentPage = val
    //    this.getList()
      },
    },
}
</script>
<style lang="scss" scoped>
.exams-item{
    width: auto !important;
    .exams-item-info{
        position: relative;
        .courseimg{
            width: 300px !important;
            height: 210px !important;
        }
        .exams-item-info-rule{
            flex-direction: column;
            height: 200px;
        }
        .dateTit{
            font-size: 13px;
            font-weight: 400;
            color: #666;
            	display: -webkit-box;  
                -webkit-line-clamp: 2;  
                -webkit-box-orient: vertical;  
                overflow: hidden;  
                text-overflow: ellipsis;
        }
        .dateTit1{
            align-items: flex-end;
             font-weight: 400;
             color: rgb(180, 183, 193);
             font-size: 13px;
        }
        .gqimg{
           width: 300px;

           position: absolute;
           right: 100px;
        }
        .coursebtn{
            display: block;
            background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                color: #fff;
                height: 36px;
                padding: 0px 18px;
                border-radius: 4px !important;
                text-decoration: none !important;
                white-space: nowrap;
                cursor: pointer;
                border: 1px solid #e4e4e4;
                box-sizing: border-box;
                line-height: 36px;
                margin-right: 20px;
                width: 120px;
                text-align: center;
                margin: -20px 0 0 0;
        }
        .coursebtn1{
            display: block;
            width: 120px;
                 height: 36px;
                 line-height: 36px;
                padding: 0px 18px;
                margin: 20px 0 0 0;
                                margin-right: 20px;
                border: 1px solid rgba(1, 87, 255, 0.2);
                border-radius: 4px;
                box-sizing: border-box;
                color: #0157ff;
                cursor: pointer;
                transition: background-color 0.3s linear 0s, border-color 0.3s linear 0s;
                text-align: center;
        }
    }
}
::v-deep{
    .jiange{
    text-align: center !important;
}
}
</style>